export function getZIndex(el: Element) {
    const inline = parseInt((el as HTMLElement).style.zIndex || '0', 10);
    const computed = parseInt(getComputedStyle(el).zIndex || '0', 10);
    // если inline есть, берём его, иначе computed (если он число)
    return Number.isFinite(inline) && inline !== 0 ? inline : Number.isFinite(computed) ? computed : 0;
}

export function clearTextSelection() {
    const doc: any = document;
    if (doc.selection) {
        doc.selection.empty();
    } else {
        window.getSelection()?.removeAllRanges();
    }
}
